import { render, staticRenderFns } from "./_form.videos.page.vue?vue&type=template&id=1fce02a1&scoped=true&"
import script from "./_form.videos.page.vue?vue&type=script&lang=js&"
export * from "./_form.videos.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.videos.page.vue?vue&type=style&index=0&id=1fce02a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce02a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VFileInput,VForm,VLayout})
